import { render, staticRenderFns } from "./OrdemServicoModal.vue?vue&type=template&id=c5d78554&scoped=true"
import script from "./OrdemServicoModal.vue?vue&type=script&lang=js"
export * from "./OrdemServicoModal.vue?vue&type=script&lang=js"
import style0 from "./OrdemServicoModal.vue?vue&type=style&index=0&id=c5d78554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d78554",
  null
  
)

export default component.exports